export default __webpack_public_path__ + "static/blur-dots-7c01e5df032a317a925237c84ba75f09.png";